import apiClient from "../../../http-common"

//Post Object API
export const postDoctor = (saveObj) => {
  return apiClient.post(`/doctorMaster/saveUpdate`, saveObj);
};


//Listing API
export const doctorListing = (searchObj) => {
  return apiClient.post(`/doctorMaster/getList`, searchObj);
};

// Autosearch API
export const doctorSearch = (searchString) => {
  return apiClient.post(`/doctorMaster/searchString/${searchString}`);
};


//Delete Row Department API
export const deleteRowDoctorApi = (index) => {
  return apiClient.delete(`/doctorMaster/deleteById/${index}`);
};


//Department  Dropdown
// export const departmentDropdownList = () => {
//   return apiClient.post(`/dropdowns/getDepartmentDropDown`);
// };

export const EmployeeCategoryDropDown = () => {
  return apiClient.post(`/dropdowns/getEmployeeCategoryDropDown`);
};

export const departmentDropdownList = (searchStr) => {
  return apiClient.post(`/dropdowns/getDepartmentDropDown/${searchStr}`);
}


export const EmployeeDropDown = (searchStr) => {
  return apiClient.post(`/dropdowns/getEmployeeDropDown/${searchStr}`);
}

// FindById API
export const doctorFindById = (cabinId) => {
  return apiClient.get(`/doctorMaster/getById/${cabinId}`);
};


//Listing API
export const occupationDropdown = () => {
  return apiClient.post(`/dropdowns/getOccupationDropDown`);
};

export const departmentDropdownSearch = (searchString) => {
  return apiClient.post(`/dropdowns/getDepartmentDropDown/${searchString}`);
}